import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { trim } from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { Settings } from 'src/app/models/settings.model';
import { Userprofile } from 'src/app/models/user/current-user.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { HomeComponent } from '../home/home.component';
import { CountryCode, CountryCodes } from 'src/app/constants/countrycodes';
import { UtilService } from 'src/app/services/util.service';

declare const $: any;

@Component({
  selector: 'app-userprofileeditor',
  templateUrl: './userprofileeditor.component.html',
  styleUrls: ['./userprofileeditor.component.css']
})
export class UserprofileeditorComponent implements OnInit {
  logofilelist: FileList;
  @ViewChild('logoimg') logoimg: ElementRef
  @ViewChild('timezoneselectorModal') timezoneselectorModal: ElementRef

  userprofile: Userprofile = new Userprofile();
  breadcrumb: BreadCrumb[] = [{ displaytext: 'Home', route: '/' }, { displaytext: 'user Profie', route: '/user/userprofile' }, { displaytext: 'Edit Profile', route: '/user/editprofile' }];
  userid: any;
  userimage: string;
  now = new Date();
  timezone: number = 0;
  timezoneinfo: any;
  timezonename: any;
  time: any;
  timeZoneInfo: any;
  countryCodes: Array<CountryCode>;
  
  constructor(public activatedroute: ActivatedRoute, public headerinfo: ComponentheaderService, private router: Router, private toastr: ToastrService,
     private usermanager: UseraccessserviceService, public settings: Settings, public util: UtilService) 
  {
    this.headerinfo.setHeaderDisplay('Profile', this.breadcrumb, []); 
    this.countryCodes = CountryCodes
  }

  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);
    this.userid = this.activatedroute.snapshot.queryParams.userid;
    await this.getprofile(this.userid);
    // var data: any = this.userprofile.timeZoneName == '' ? await this.usermanager.getClientIPInfo().toPromise() : null;
    if(!this.userprofile.timeZoneName){
      try{
        this.timezoneinfo = this.usermanager.getClientTimezoneInfo();
      }
      catch(error){
        console.error(error);
        this.timezoneinfo = { timezone_offset: 1, timezone: 'Africa/Lagos' };
      }
    }
    else{
      this.timezoneinfo = { timezone_offset: this.userprofile.timeZone, timezone: this.userprofile.timeZoneName };
    }
    this.timezone = this.userprofile.timeZoneName == '' ? this.timezoneinfo.timezone_offset : this.userprofile.timeZone;
    this.timezonename = this.userprofile.timeZoneName == '' ? this.timezoneinfo.timezone : this.userprofile.timeZoneName;
    this.timeZoneInfo = this.timezonename;
    this.now = new Date(this.timezoneinfo.date_time);
    this.now.toLocaleString('en-US', { timeZone: this.timezonename })
    console.log(this.timezone);

    if (this.userprofile.timeZoneName != '') {
      this.now = new Date();
      this.now.toLocaleString('en-US', { timeZone: this.timezonename })
      console.log(this.timezone);
    }
    else {
      this.now = new Date(this.timezoneinfo.date_time);
      this.now.toLocaleString('en-US', { timeZone: this.timezonename })
    }

    setInterval(() => {

      this.now = new Date();
      this.time = this.now.toLocaleString('en-US', { timeZone: this.timezonename })

    }, 1000);
    this.headerinfo.pageLoadingDone(this);
  }
  async getprofile(userid: any) {
    var currentuserid: any = (await this.usermanager.isAlive().toPromise()).id;
    this.userimage = (await this.usermanager.getuserprofileimage(userid).toPromise()).url;
    this.userprofile = await this.usermanager.getuserprofile(userid).toPromise();
    console.log(JSON.stringify(this.userprofile));

    if (currentuserid != this.userprofile.userId) {
      this.toastr.error('Unauthorised action');
      this.router.navigate(['/user/userprofile'], { queryParams: { userid: currentuserid } })
    }
    this.headerinfo.setHeaderDisplay(
      'Edit Profile',
      [
        { displaytext: 'User Profie', route: '/user/userprofile', params: { userid: this.userid } },
        { displaytext: 'Edit Profile', route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams }
      ],
      []);
  }

  async createupdateuserprofile() {
    // if (this.logofilelist && this.logofilelist.length > 0 && !this.handleLogoImageLoaded()) {
    //   return;
    // }
    if (this.userprofile.safeBio.length > 1000) {
      this.toastr.error('Description too large');
    }
    else {
      this.userprofile.timeZoneName = this.timezonename ? this.timezonename : this.userprofile.timeZoneName;
      this.userprofile.timeZone = this.timezone !=null && this.timezone!=undefined ? this.timezone : this.userprofile.timeZone;
      this.userprofile.bio = this.userprofile.safeBio;
      const data: any = await this.usermanager.createuserprofile(this.userprofile).toPromise();
      const userprofileid = data.id;
      if (this.logofilelist && this.logofilelist.length > 0) {
        await this.usermanager.uploadUserImage(this.logofilelist[0]).toPromise();
      }
      //this.toastr.success('User Profile saved');
      this.router.navigate(['/user/userprofile'], { queryParams: { userid: userprofileid } }).then(() => {
        const _window: any = window;
        _window.location.reload(true);
      });
    }
  }

  handleLogoFileChange(files: FileList) {
    //
    this.logofilelist = files;
    this.logoimg.nativeElement.src = URL.createObjectURL(files[0]);
  }

  // handleLogoImageLoaded(): boolean {
  //
  //   const sizevalid: boolean = this.validateuserprofileImage();

  //   if (!sizevalid) {
  //     this.toastr.error(`The image supplied is the wrong size. Image dimensions must be ${this.settings.userImageWidth} x ${this.settings.userImageHeight}`);
  //     return false;
  //   }
  //   else {
  //     return true;
  //   }
  // }

  // validateuserprofileImage(): boolean {
  //   const img = this.logoimg.nativeElement;

  //   let imageWidth = img.naturalWidth;
  //   let imageHeight = img.naturalHeight;

  //   if (Math.abs(imageWidth - this.settings.userImageWidth) > 2 || Math.abs(imageHeight - this.settings.userImageHeight) > 2) {
  //     return false;
  //   }
  //   else {
  //     return true;
  //   }
  // }
  // getvalue(value: any) {
  //   console.log(JSON.stringify(value));
  //   // var newYork    = this.moment('Wed Aug 30 2017 00:00:00 GMT+0530', 'ddd MMM DD YYYY HH:mm:ss GMT+-HH:mm').format('YYYY-M-DD');

  //   // var losAngeles = newYork.clone().tz("America/Los_Angeles");
  //   debugger;
  //   this.timezonename = value.nameValue.name;
  //   var longstring = value.timeValue.toString().split(':');
  //   this.timezone = parseInt(longstring[0].toString().trim().replace(':', '').replace('"', '').replace('+', ''));

  // }
  async savetimezone() {
    // if(val){
    this.userprofile.timeZoneName = this.timeZoneInfo.nameValue;
    const longstring = this.timeZoneInfo.timeValue.toString().split(':');
    this.userprofile.timeZone = parseInt(longstring[0].toString().trim().replace(':', '').replace('"', '').replace('+', ''));
    const data: any = (this.timezonename) ? await this.usermanager.createuserprofile(this.userprofile).toPromise() : null;
    $(this.timezoneselectorModal.nativeElement).modal('hide');
    if (data) this.toastr.success("User setting saved");
    setTimeout(() => {
      const _window: any = window;
      _window.location.reload(true);
    }, 1000);
    // }
  }

  getPhoneNumberValidator() {
    return this.util.getPhoneNumberRegexPattern(this.userprofile.countrycode, this.userprofile.phoneno[0]);
  }

  patternPassed(){
    let number = this.util.reFormatNGorUKPhoneNumber(this.userprofile.phoneno, this.userprofile.countrycode);
    this.userprofile.phoneno = number;
    return this.getPhoneNumberValidator().test(number);
  }

  openmodal() {
    $(this.timezoneselectorModal.nativeElement).modal('show');

  }
}
